import ArrowLink from './ArrowLink';

export default ArrowLink;
